import React from 'react';
import useOverlayStateFromUrl from '../../Overlays/useOverlay';
import Header from '../index';

const HeaderWithSingletonHooks: React.FC<{ detachedHeaderMode: boolean }> = ({ detachedHeaderMode }) => {
    useOverlayStateFromUrl();
    return <Header detachedHeaderMode={detachedHeaderMode} />;
};
export default HeaderWithSingletonHooks;
